var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.report)?_c('Feedback'):_vm._e(),(_vm.report)?_c('Report'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }